<template>
  <div class="col-md-12">
    <div class="card">
      <div class="card-header p-2 text-center bg-primary text-white">
        <h4>Administrador Proceso Comprobante de Pago de Pensión</h4>
      </div>

      <div class="card-body">
        <!-- Spinner -->
        <div v-if="loading" class="spinner-overlay">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

        <fieldset class="border p-2">
          <legend class="w-auto">Filtro de Búsqueda</legend>
          <form>

            <div class="form-row">
              <!-- Periodo field -->
              <div class="col">
                <div class="form-group">
                  <label for="period">Periodo </label>
                  <input type="number" id="period" v-model="period" @input="onPeriodChange" class="form-control"
                    placeholder="YYYYMM" required />
                  <span v-if="periodErrorMessage" class="text-danger">{{ periodErrorMessage }}</span>
                </div>
              </div>

              <!-- ID de Liquidación field-->
              <div class="col">
                <div class="form-group">
                  <label for="idLiquidacion"> ID de Liquidación</label>
                  <input type="text" v-model="idLiquidacion" class="form-control" id="idLiquidacion">
                </div>
              </div>
              <!-- rut Beneficiario field-->
              <div class="col">
                <div class="form-group">
                  <label for=" RUT Beneficiario"> RUT Beneficiario</label>
                  <input type="text" id="beneficiaryID" class="form-control" v-model="beneficiaryID"
                    @input="formatRut('beneficiaryID')" :class="{ 'is-invalid': beneficiaryIDError }"
                    placeholder="XXXXXXXX-X" />
                  <div v-if="beneficiaryIDError" class="invalid-feedback">Rut inválido</div>
                </div>
              </div>
              <!-- CSV Notificación fecha pago field -->
              <div class="col">
                <div class="form-group">
                  <label for="¿CSV Notificación fecha pago?"> ¿CSV Notificación fecha pago?</label>
                  <div class="input-group">
                    <select v-model="csvPaymentDateNotification" class="form-control" id="csvPaymentDateNotification">
                      <option :value="true">Sí</option>
                      <option :value="false">NO</option>
                    </select>
                    <div class="input-group-append" v-if="csvPaymentDateNotification !== null">
                      <button class="btn btn-outline-secondary" type="button"
                        @click="csvPaymentDateNotification = null"> ✕ </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Cargado IPS field -->
              <div class="col">
                <div class="form-group">
                  <label for="¿Cargado IPS?"> ¿Cargado IPS?</label>
                  <div class="input-group">
                    <select v-model="ipsLoaded" class="form-control" id="ipsLoaded">
                      <option :value="1">Sí</option>
                      <option :value="2">NO</option>
                      <option :value="0">ERROR</option>
                    </select>
                    <div class="input-group-append" v-if="ipsLoaded !== null">
                      <button class="btn btn-outline-secondary" type="button" @click="ipsLoaded = null"> ✕ </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- ID Batch field -->

            <div class="form-row">

              <div class="col">
                <div class="form-group">
                  <label for="processBatchId">ID Batch </label>
                  <div class="input-group">
                    <select id="selectedProcessBatchId" v-model="selectedProcessBatchId" class="form-control">
                      <option v-for="batch in processBatchIds" :key="batch" :value="batch">
                        {{ batch }}
                      </option>
                    </select>
                    <div class="input-group-append" v-if="selectedProcessBatchId !== null">
                      <button class="btn btn-outline-secondary" type="button" @click="selectedProcessBatchId = null"> ✕
                      </button>
                    </div>
                  </div>
                  <span v-if="processBatchError" class="text-danger">{{ processBatchError }}</span>
                </div>
              </div>

              <div class="col">
                <div class="form-group">
                  <label for="RUT Cliente"> RUT Cliente</label>
                  <input type="text" id="customer-id" class="form-control" v-model="customerID"
                    @input="formatRut('customerID')" :class="{ 'is-invalid': customerIDError }"
                    placeholder="XXXXXXXX-X" />
                  <div v-if="customerIDError" class="invalid-feedback">Rut inválido</div>
                </div>
              </div>
              <!-- PGU -->
              <div class="col">
                <div class="form-group">
                  <label for="¿Beneficio IPS?">¿Beneficio IPS?</label>
                  <div class="input-group">
                    <select v-model="isPGU" class="form-control" id="isPGU">
                      <option :value="true">Sí</option>
                      <option :value="false">NO</option>
                    </select>
                    <div class="input-group-append" v-if="isPGU !== null">
                      <button class="btn btn-outline-secondary" type="button" @click="isPGU = null"> ✕ </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- renderizado -->
              <div class="col">
                <div class="form-group">
                  <label for="¿Renderizado?"> ¿Renderizado?</label>
                  <div class="input-group">
                    <select v-model="isRendered" class="form-control" id="isRendered">
                      <option value="Success">Sí</option>
                      <option value="NotRendered">NO</option>
                      <option value="Failed">ERROR</option>
                    </select>
                    <div class="input-group-append" v-if="isRendered !== null">
                      <button class="btn btn-outline-secondary" type="button" @click="isRendered = null"> ✕ </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col">
                <div class="form-group">
                  <label class="small" for="¿CSV Notificación Comprobante de
                      Pago?"> ¿CSV Notificación Comprobante de
                    Pago?</label>
                  <div class="input-group">
                    <select v-model="csvPaymentProofNotification" class="form-control" id="csvPaymentProofNotification">
                      <option :value="true">Sí</option>
                      <option :value="false">NO</option>
                    </select>
                    <div class="input-group-append" v-if="csvPaymentProofNotification !== null">
                      <button class="btn btn-outline-secondary" type="button"
                        @click="csvPaymentProofNotification = null"> ✕ </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-3">
                <div class="form-group">
                  <label for="processType">Tipo de Proceso</label>
                  <div class="input-group">
                    <select v-model="processType" class="form-control" id="processType">
                      <option value="Standard">Estándar</option>
                      <option value="ReProcess">Reproceso</option>
                    </select>
                    <div class="input-group-append" v-if="processType !== null">
                      <button class="btn btn-outline-secondary" type="button" @click="processType = null"> ✕ </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col">

                <div class="form-group button-group">

                  <!-- search button -->
                  <button type="button" class="btn btn-primary float-right mr-2" @click="search"
                    :disabled="periodErrorMessage || period === ''">
                    Buscar
                  </button>

                  <!-- reprocess button  -->
                  <button type="button" class="btn btn-primary float-right mr-2" data-toggle="modal"
                    data-target="#confirmationModal"
                    :disabled="periodErrorMessage || period === '' || adminProcessingSummary.length === 0">
                    Reprocesar
                  </button>

                  <!-- export button -->
                  <button type="button" class="btn btn-primary float-right mr-2"
                    :disabled="periodErrorMessage || period === '' || !adminProcessingSummary || adminProcessingSummary.length === 0"
                    @click="exportSelectionCVS">
                    Exportar selección
                  </button>

                  <!-- clear button -->
                  <button type="button" class="btn btn-primary float-right mr-2" @click="clearData" :disabled="!period">
                    Limpiar Filtros
                  </button>




                  <!-- confirmation sumamary Popup  -->
                  <div class="modal fade" id="confirmationModal" tabindex="-1" role="dialog"
                    aria-labelledby="confirmationModalLabel">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                      <div class="modal-content">
                        <fieldset class="border m-3">
                          <div class="modal-header">
                            <legend class="w-auto">¿Cúal flujo quiere reprocesar?</legend>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                              <span>&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <div class="row">
                              <div class="col-md-9 mx-auto my-3">
                                <table class="custom-table">
                                  <tr>
                                    <td>
                                      <div class="form-check">
                                        <input class="form-check-input" type="checkbox"
                                          value="CSV Notificación fecha pago" id="CSVNotificaciónfechapago"
                                          v-model="ReprocessOptionValue['CSV Notificación fecha pago']">
                                        <label class="form-check-label" for="CSVNotificaciónfechapago">
                                          CSV Notificación Fecha Pago
                                        </label>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="Renderizado"
                                          id="Renderizado" v-model="ReprocessOptionValue['Renderizado']">
                                        <label class="form-check-label" for="Renderizado">
                                          Renderizado Link
                                        </label>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <div class="form-check">
                                        <input class="form-check-input" type="checkbox"
                                          value="CSV Notificación comprobante pago" id="CSVNotificaciónComprobantePago"
                                          v-model="ReprocessOptionValue['CSV Notificación comprobante pago']">
                                        <label class="form-check-label" for="CSVNotificaciónComprobantePago">
                                          CSV Notificación Comprobante Pago
                                        </label>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="Carga IPS" id="CargaIPS"
                                          v-model="ReprocessOptionValue['Carga IPS']" :disabled="isPGU === false">
                                        <label class="form-check-label" for="CargaIPS">
                                          Cargar en IPS
                                        </label>
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </div>

                            <!-- Section for User Input -->
                            <div class="row">
                              <div class="col-md-9 mx-auto my-3">
                                <label for="userComment">Comentario:</label>
                                <textarea id="userComment" class="form-control" v-model="userComment"
                                  placeholder="Ingrese su comentario aquí..." rows="3"></textarea>
                              </div>
                            </div>
                          </div>


                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                            <button type="button" class="btn btn-primary" data-target="#optionModal" data-toggle="modal"
                              data-dismiss="modal" :disabled="!isAnyOptionSelected || !userComment">Confirmar</button>
                          </div>

                        </fieldset>
                      </div>
                    </div>
                  </div>

                  <!-- option pop up modal -->
                  <div class="modal " id="optionModal" aria-labelledby="optionModalLabel" tabindex="-1">
                    <div class="modal-dialog modal-dialog-centered modal-lg">
                      <div class="modal-content">
                        <fieldset class="border m-3">

                          <div class="modal-header">
                            <legend class="w-auto">Confirmar Reproceso</legend>

                            <h5 class="modal-title fs-5" id="optionModalLabel"></h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                              <span>&times;</span>
                            </button>
                          </div>


                          <div class="modal-body">
                            ¿Está seguro que desea reprocesar el renderizado según los siguientes filtros?
                            <div class="col-md-12 mx-auto my-3">
                              <div class="table-grid">
                                <div v-if="period">
                                  <strong>Periodo:</strong>
                                  <span>{{ period }}</span>
                                </div>
                                <div v-if="idLiquidacion">
                                  <strong>ID de Liquidación:</strong>
                                  <span>{{ idLiquidacion }}</span>
                                </div>
                                <div v-if="beneficiaryID">
                                  <strong>RUT Beneficiario:</strong>
                                  <span>{{ beneficiaryID }}</span>
                                </div>
                                <div v-if="csvPaymentDateNotification !== null">
                                  <strong>¿CSV Notificación fecha pago?</strong>
                                  <span>{{ csvPaymentDateNotification ? 'SI' : 'NO' }}</span>
                                </div>
                                <div v-if="ipsLoaded !== null">
                                  <strong>¿Cargado IPS?</strong>
                                  <span>{{ ipsLoaded === 1 ? 'SI' :
                                    ipsLoaded === 0 ? 'NO' :
                                    ipsLoaded === 2 ? 'ERROR' :
                                    ipsLoaded }}</span>
                                </div>
                                <div v-if="selectedProcessBatchId">
                                  <strong>ID Batch:</strong>
                                  <span>{{ selectedProcessBatchId }}</span>
                                </div>
                                <div v-if="customerID">
                                  <strong>RUT Cliente:</strong>
                                  <span>{{ customerID }}</span>
                                </div>
                                <div v-if="isPGU !== null">
                                  <strong>¿PGU?</strong>
                                  <span>{{ isPGU ? 'SI' : 'NO' }}</span>
                                </div>
                                <div v-if="isRendered">
                                  <strong>¿Renderizado?</strong>
                                  <span>{{ isRendered === 'Success' ? 'SI' :
                                    isRendered === 'NotRendered' ? 'NO' :
                                    isRendered === 'Failed' ? 'ERROR' :
                                    isRendered }}</span>
                                </div>
                                <div v-if="csvPaymentProofNotification !== null">
                                  <strong>¿CSV Notificación Comprobante de Pago?</strong>
                                  <span>{{ csvPaymentProofNotification ? 'SI' : 'NO' }}</span>
                                </div>
                              </div>

                              <table class="table">
                                <tr>
                                  <th>Opciones Seleccionadas </th>
                                  <td>
                                    <ul>
                                      <li v-for="(value, key) in ReprocessOptionValue" :key="key" v-if="value">
                                        {{ key }}
                                      </li>
                                    </ul>
                                  </td>
                                </tr>
                              </table>
                              <table class="table">
                                <tr>
                                  <th>Nombre</th>
                                  <td>{{ userName }}</td>
                                  <th v-if="userComment">Comentario</th>
                                  <td>{{ userComment }}</td>

                                </tr>
                              </table>
                            </div>



                          </div>

                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                            <button type="button" class="btn btn-secondary" data-target="#confirmationModal"
                              data-toggle="modal" data-dismiss="modal" @click="">Volver</button>
                            <button class="btn btn-primary" data-dismiss="modal" data-toggle="modal"
                              @click="triggerReprocessStepfunction">Continuar</button>
                          </div>

                        </fieldset>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </form>
        </fieldset>
        <!-- adminProcessingSummary -->
        <fieldset class="border p-2" v-if="adminProcessingSummary && adminProcessingSummary.length">
          <legend class="w-auto">Resumen Procesamiento </legend>

          <div class="row">
            <div class="col-md-12">
              <div class="table-container">


                <table class="table table-striped ">
                  <thead>
                    <tr>
                      <th class="small" v-for="item in adminProcessingSummaryHeading" v-bind:key="item.name">{{ item }}</th>
                    </tr>
                  </thead>
                  <tbody style="height: 300px ; overflow-y: auto;">
                    <tr v-for="(process) in adminProcessingSummary"
                      :key="`${process.idLiquidacion}-${process.batchId}-${process.startTime}`">
                      <td>{{ formatString(process.startTime) }}</td>
                      <td>{{ process.periodo }}</td>
                      <td>{{ process.idLiquidacion }}</td>
                      <td>{{ process.batchId }}</td>
                      <td>{{ process.rutCliente }}</td>
                      <td>{{ process.rutBeneficiario }}</td>
                      <td>{{ formatField(process.pgu) }}</td>
                      <td>{{ formatString(process.csvPaymentDateNotification) }}</td>
                      <td>{{ formatString(process.renderStatus) }}</td>
                      <td>{{ formatString(process.processType) }}</td>
                      <td>{{ formatString(process.errorReason) }}</td>
                      <td>{{ process.ipsLoaded }}</td>
                      <td>{{ formatString(process.csvPaymentProofNotification) }}</td>

                    </tr>
                  </tbody>
                </table>
              </div>
              <nav aria-label="Page navigation example">
                <ul class="pagination justify-content-end">
                  <div class="btn-group btn-group-sm my-2" role="group" aria-label="Basic example">
                    <button type="button" class="btn page-link px-3 large-symbol" @click="firstPage"
                      :disabled="currentPage === 1">&laquo;</button>
                    <button type="button" class="btn page-link px-3 large-symbol" @click="prevPage"
                      :disabled="currentPage === 1">&lsaquo;</button>
                    <button type="button" class="btn page-item px-3 p-2 ">Page {{ currentPage }} of {{ totalPages
                      }}</button>
                    <button type="button" class="btn page-link px-3 large-symbol" @click="nextPage"
                      :disabled="currentPage === totalPages">&rsaquo;</button>
                    <button type="button" class="btn page-link px-3 large-symbol" @click="lastPage"
                      :disabled="currentPage === totalPages">&raquo;</button>
                  </div>


                </ul>
              </nav>
            </div>
          </div>

        </fieldset>

      </div>
    </div>
  </div>
</template>

<script>
import PdfRendringService from '../services/PdfRendringService'
import Paginate from 'vuejs-paginate';
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
import {
  CvsFileGenerator,
  downloadPDF,
  downloadCSV,
  CvsFileGeneratorBase64,
  CurrentPeriod,
  validatePeriodData,
  formatRutData,
  validateRUTData
} from '../services/common'
export default {
  name: "Administrative",
  components: {
    Paginate
  },
  props: {},
  data() {
    return {
      userId: "",
      userName: "",
      token: "",
      period: '', // Period input value
      idLiquidacion: '',//idliuidacion input value
      beneficiaryID: '',  // Beneficiary ID (RUT) input value
      csvPaymentDateNotification: null, //1st notifaction
      ipsLoaded: null, // IPS loaded
      processBatchIds: [], // Fetached Batch ID list
      selectedProcessBatchId: null, //selected Batch ID
      customerID: '', // Customer ID (RUT) input value
      isPGU: null, //PDF is PGU or NON-pgu
      isRendered: null, //PDF is Rendered or NOT
      csvPaymentProofNotification: null, //2nd notification

      periodError: false, // Period input error flag
      customerIDError: false, // Customer ID (RUT) input error flag
      beneficiaryIDError: false,
      processBatchError: false, //Batch ID Error



      // Resumen Procesamiento  table heading

      adminProcessingSummaryHeading:
        ["Fecha Proceso",
          "Periodo",
          "ID Liquidación",
          "ID Batch",
          "Rut Cliente",
          "Rut Beneficiario",
          "¿IPS?",
          "¿CSV Notificación fecha pago?",
          "¿Renderizado?",
          "Tipo de Proceso",
          "Motivo Error",
          "¿Cargado IPS?",
          "¿CSV Notificación Comprobante Pago?"
          ],
      // Resumen Procesamiento  Api Data
      adminProcessingSummary: [],

      ReprocessOptionValue: {
        'CSV Notificación fecha pago': false,
        'Renderizado': false,
        'CSV Notificación comprobante pago': false,
        'Carga IPS': false
      },
      processType: null,
      userComment: '',
      currentPage: 1,
      itemsPerPage: 10,
      totalRecords: 0,
      errors: {},
      periodErrorMessage: '',
      selectAllProcessSummaryChecked: false,
      isSelectAllProcessSummaryChecked: false,
      loading: false
    };
  },
  watch: {
    period() {
      this.clearAdminProcessingSummary();
    },
    idLiquidacion() {
      this.clearAdminProcessingSummary();
    },
    beneficiaryID() {
      this.clearAdminProcessingSummary();
    },
    csvPaymentDateNotification() {
      this.clearAdminProcessingSummary();
    },
    ipsLoaded() {
      this.clearAdminProcessingSummary();
    },
    selectedProcessBatchId() {
      this.clearAdminProcessingSummary();
    },
    customerID() {
      this.clearAdminProcessingSummary();
    },
    isPGU() {
      this.clearAdminProcessingSummary();
    },
    isRendered() {
      this.clearAdminProcessingSummary();
    },
    csvPaymentProofNotification() {
      this.clearAdminProcessingSummary();
    }
  },
  mounted() {
    this.userId = this.$route.query.idusuario;
    this.userName = this.$route.query.nombre;
    this.clientId = this.$route.query.clientid;
    this.clientSecret = this.$route.query.clientsecret;
    this.getToken();
  },

  computed: {

    isBulk() {
      return (
        (this.selectedProcessBatchId ||
          this.period) &&
        !this.idLiquidacion &&
        !this.beneficiaryID &&
        this.csvPaymentDateNotification === null &&
        this.ipsLoaded === null &&
        !this.customerID &&
        this.isPGU === null &&
        this.isRendered === null &&
        this.csvPaymentProofNotification === null
      );
    },

    isAnyOptionSelected() {
      return Object.values(this.ReprocessOptionValue).some(value => value);
    },
    isSearchDisabled() {
      return this.period.trim() === "";
    },
    totalPages() {
      return Math.ceil(this.totalRecords / this.itemsPerPage);
    }

  },


  methods: {

    getToken() {
      PdfRendringService.getCognitoToken(this.clientId, this.clientSecret)
        .then(res => {
          if (res.data) {
            this.token = res.data.access_token
          }
        }).catch(error => {
          this.token = ""
        })
    },
    formatField(field) {
      if (field == 1) {
        return 'SI';
      }
      else if (field == 0) {
        return 'NO';
      }

    },
    formatString(value) {
      return value === null || value === '' ? '--' : value;
    },
    clearAdminProcessingSummary() {
      this.adminProcessingSummary = [];
    },
    clearData() {
      // Reset all input fields
      this.period = '';
      this.idLiquidacion = '';
      this.beneficiaryID = '';
      this.csvPaymentDateNotification = null;
      this.ipsLoaded = null;
      this.selectedProcessBatchId = null;
      this.customerID = '';
      this.isPGU = null;
      this.isRendered = null;
      this.csvPaymentProofNotification = null;
      this.processType = null;

      // Clear error messages
      this.periodErrorMessage = '';
      this.customerIDError = false;
      this.beneficiaryIDError = false;
      this.processBatchError = false;

      // Clear table data and pagination
      this.adminProcessingSummary = [];
      this.totalRecords = 0;
      this.currentPage = 1;

      // Clear any other related state
      this.processBatchIds = [];
      this.loading = false;

    },

    onPeriodChange() {
      if (!this.period) {
        this.selectedProcessBatchId = null; //Clear Batch Id when period is cleared
        this.processBatchIds = [];
        this.adminProcessingSummary = [];
        this.totalRecords = 0;
        this.currentPage = 1;
      } else {
        this.selectedProcessBatchId = null;
        this.currentPage = 1;
        this.totalRecords = 0;
        this.validateProcessPeriod();
      }

    },
    validateProcessPeriod() {
      const periodRegex = /^\d{4}(0[1-9]|1[0-2])$/;
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1;

      if (!this.period.match(periodRegex)) {
        this.periodErrorMessage = "El período debe estar en formato AAAAMM.";
      } else if (
        parseInt(this.period.substring(0, 4)) > currentYear ||
        (parseInt(this.period.substring(0, 4)) === currentYear &&
          parseInt(this.period.substring(4, 6)) > currentMonth)
      ) {
        this.periodErrorMessage = "Periodo no puede ser una fecha futura.";
      } else if (
        parseInt(this.period.substring(4, 6)) < 1 ||
        parseInt(this.period.substring(4, 6)) > 12
      ) {
        this.periodErrorMessage = "El mes debe estar entre 01 y 12.";
      } else {
        this.periodErrorMessage = "";
        this.fetchBatchData(); // Fetch data if validation is successful
      }
    },


    search() {
      // this.isLoader = true;
      // this.isVisible = false;
      // this.isVisibleResumen = false;
      this.adminProcessingSummary = [];
      this.totalRecords = 0;
      this.periodError = false;
      this.customerIDError = false;
      this.beneficiaryIDError = false;
      // if (this.period) this.validateProcessPeriod();
      if (this.customerID) this.formatRut('customerID');
      if (this.beneficiaryID) this.formatRut('beneficiaryID');
      this.fetchProcessingSummaryData();
    },

    fetchBatchData() {
      this.loading = true; // Show spinner while loading data

      PdfRendringService.getAdminProcess(this.token, this.period)
        .then(res => {
          if (res.data.length === 0) {
            this.$notify({
              group: 'foo',
              type: "error",
              text: 'No se encontraron datos',
            });
            this.processBatchIds = [];
          } else {
            this.processBatchIds = [...res.data];
          }
          this.loading = false; // Hide spinner after data is loaded
        }).catch(error => {
          // this.isLoader = false;
          // this.isVisibleResumen = false;
          // this.setCurrentPeriodData(null);
          this.$notify({
            group: 'foo',
            type: "error",
            text: 'no se encontraron datos'
          })

        })
    },

    //Processing table data
    fetchProcessingSummaryData() {
      this.loading = true;
      this.getToken();


      const filters = {

        periodo: this.period,
        idLiquidacion: this.idLiquidacion,
        rutBeneficiario: this.beneficiaryID,
        csvPaymentDateNotification: this.csvPaymentDateNotification,
        ipsLoaded: this.ipsLoaded,
        batchId: this.selectedProcessBatchId,
        rutCliente: this.customerID,
        pgu: this.isPGU,
        renderStatus: this.isRendered,
        csvPaymentProofNotification: this.csvPaymentProofNotification,
        CurrentPage: this.currentPage,
        Limit: this.itemsPerPage,
        processType: this.processType,
      };
      const formData = Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v != null && v !== '')
      );
      PdfRendringService.getProcessingSummaryData(this.token, formData)
        .then(res => {

          if (res.data.length === 0) {
            this.$notify({
              group: 'foo',
              type: "error",
              text: 'No se encontraron datos',
            });
            this.adminProcessingSummary = [];
            this.totalRecords = 0;
          } else {
            this.adminProcessingSummary = res.data;
            this.totalRecords = res.data[0].totalRecordsCount;

          }
          this.loading = false; // Hide spinner after data is loaded
        }).catch(error => {

          this.isLoader = false;
          this.isVisibleResumen = false;
          this.loading = false; // Hide spinner after data is loaded
          this.$notify({
            group: 'foo',
            type: "error",
            text: 'no se encontraron datos'
          })

        })
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.search();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.search();
      }
    },
    lastPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage = this.totalPages;
        this.search();
      }

    },
    firstPage() {
      if (this.currentPage > 1) {
        this.currentPage = 1;
        this.search();
      }

    },
    // CSV download function
    exportSelectionCVS() {
      this.getToken();

      const CSVFilters = {
        periodo: this.period,
        idLiquidacion: this.idLiquidacion,
        rutBeneficiario: this.beneficiaryID,
        csvPaymentDateNotification: this.csvPaymentDateNotification,
        ipsLoaded: this.ipsLoaded,
        batchId: this.selectedProcessBatchId,
        rutCliente: this.customerID,
        pgu: this.isPGU,
        renderStatus: this.isRendered,
        csvPaymentProofNotification: this.csvPaymentProofNotification,
        processType: this.processType,
      };
      const CSVformData = Object.fromEntries(
        Object.entries(CSVFilters).filter(([_, v]) => v != null && v !== '')
      );

      PdfRendringService.getAdminExportSelectionCVS(this.token, CSVformData)
        .then(res => {
          if (res.data.includes('No Data Found To Generate CSV File')) {
            this.$notify({
              group: 'foo',
              type: "error",
              text: 'No se encontraron datos para generar el archivo CSV',
            });
          } else {
            downloadCSV(res.data);

          }

        }).catch(error => {

          this.$notify({
            group: 'foo',
            type: "error",
            text: 'no se encontraron datos'
          })

        })
    },

    // Reprocess Function
    triggerReprocessStepfunction() {
      this.getToken();
      const reprocessFilters = {
        periodo: this.period,
        idLiquidacion: this.idLiquidacion,
        rutBeneficiario: this.beneficiaryID,
        csvPaymentDateNotification: this.csvPaymentDateNotification,
        ipsLoaded: this.ipsLoaded,
        batchId: this.selectedProcessBatchId,
        rutCliente: this.customerID,
        pgu: this.isPGU,
        renderStatus: this.isRendered,
        processType: this.processType,
        csvPaymentProofNotification: this.csvPaymentProofNotification,
        userId: this.userId,
        username: this.userName,
        comment: this.userComment,
        isBulk: this.isBulk,
        Filter: {
          LoadBase64: this.ReprocessOptionValue['Carga IPS'],
          GenerateFirstNotification: this.ReprocessOptionValue['CSV Notificación fecha pago'],
          RenderLink: this.ReprocessOptionValue['Renderizado'],
          GenerateSecondtNotification: this.ReprocessOptionValue['CSV Notificación comprobante pago'],
        },
      };
      const ReprocessFormFilters = Object.fromEntries(
        Object.entries(reprocessFilters).filter(([_, v]) => v != null && v !== '')
      );

      PdfRendringService.sendAdminReprocessByFilter(this.token, ReprocessFormFilters)
        .then(res => {
          if (res.data) {
            this.$notify({
              group: 'foo',
              type: "success",
              text: 'Formulario de proceso enviado exitosamente',
            });
          }
          else {
            this.$notify({
              group: 'foo',
              type: "error",
              text: 'Ya existe una ejecución en curso para el batch seleccionado o existe otro periodo en proceso.'
            });
          }
        }).catch(error => {
          this.$notify({
            group: 'foo',
            type: "error",
            text: 'no se encontraron datos'
          })

        })
      this.ReprocessOptionValue = {
        'CSV Notificación fecha pago': false,
        'Renderizado': false,
        'CSV Notificación comprobante pago': false,
        'Carga IPS': false
      }
      this.userComment = '';

    },

    formatRut(field) {
      let value = this[field];

      // Remove non-numeric characters and transform to upper case for validation
      value = value.replace(/[^\dkK]/g, '').toUpperCase();

      if (value.length === 0) {
        this[`${field}Error`] = false;//remove error if the input is empty
        this[field] = value;
        return;
      }
      if (value.length > 1) {
        const rut = value.slice(0, -1);
        const dv = value.slice(-1);
        this[field] = `${rut}-${dv}`;
        this[`${field}Error`] = !this.validateRUT(this[field]);
      } else {
        this[field] = value;
        this[`${field}Error`] = value.length === 1 ? !this.validateRUT(`${value.slice(0, -1)}-${value.slice(-1)}`) : true;
      }
    },
    validateRUT(rut) {
      if (!/^[0-9]+-[0-9kK]{1}$/.test(rut)) return false;

      const parts = rut.split('-');
      const dv = parts[1];
      const rutNumber = parts[0].replace(/\./g, ''); // Remove dots

      let T = rutNumber;
      let M = 0;
      let S = 1;

      for (; T; T = Math.floor(T / 10)) {
        S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
      }

      const calculatedDV = S ? S - 1 : 'k';

      return dv.toLowerCase() === calculatedDV.toString();
    },
  },
};
</script>
<style scoped>
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  /* Optional: Add a semi-transparent background */
  z-index: 9999;
  /* Ensure spinner is on top */
}

.large-symbol {
  font-size: 1.2em;
  color: black;
}

.table-container {
  max-height: 350px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
}

.custom-table tr {
  border-bottom: 1px solid #ddd;
}

.custom-table tr:hover {
  background-color: #f1f1f1;
}

.custom-table td {
  padding: 12px 18px;
}

/* Checkbox Styling */
.form-check {
  display: flex;
  align-items: center;
}

.form-check-input {
  margin-right: 10px;
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.form-check-label {
  font-size: 14px;
  color: #333;
  cursor: pointer;
}

.table-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  /* Two columns */
  gap: 10px 30px;
  /* Space between rows and columns */
  width: 100%;
}

.table-grid div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
  border-bottom: 1px solid #ddd;

}

.table-grid div strong,
th {
  font-weight: 700;
  color: #333;
  font-size: 13px;
}

.table-grid div span {
  color: #252525;
  text-align: right;
}

@media (max-width: 768px) {
  .table-grid {
    grid-template-columns: 1fr;
    /* Switch to single column on smaller screens */
  }
}

.col-3 {
  flex: 0 0 20%;
  max-width: 25%;
}

.button-group {
  display: flex;
  align-items: center;
  /* Vertically centers the buttons */
  justify-content: flex-end;
  /* Aligns buttons to the right */
  height: 100%;
  /* Ensures the div takes the full height of its container */
}

.input-group-append .btn {
  z-index: 2;
  border: 1px solid #ced4da;
  color: #6c757d;
}

.input-group-append .btn:hover {
  background-color: #e2e6ea;
  color: #242525;
}
.table-container table tr,
.table-container table td,
.table-container table th {
  height: 30px;      /* Set your desired fixed height */
  min-height: 30px;
  vertical-align: middle !important; /* Vertically center content */
  box-sizing: border-box;
}
.form-check {
  display: flex;
  align-items: center;
  margin-bottom: 0; /* Remove extra space between rows */
}

.form-check-input {
  margin-right: 10px;
  margin-top: 0;
  margin-bottom: 0;
  width: 18px;
  height: 18px;
  cursor: pointer;
  vertical-align: middle;
  position: relative;
  top: 0;
}

.form-check-label {
  font-size: 14px;
  color: #333;
  cursor: pointer;
  line-height: 1;
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Administrative.vue